export const dashboardFilters = [
    {
        key: 'today',
        label: 'Today' 
    },
    {
        key: 'last_7_days',
        label: 'Last 7 Days' 
    },
    {
        key: 'last_30_days',
        label: 'Last 30 Days' 
    },
    {
        key: 'last_6_months',
        label: 'Bi Annual' 
    },
    {
        key: 'last_12_months',
        label: 'Annual' 
    },
    {
        key: 'custom',
        label: 'Custom' 
    }
];

export const ordersChartFilters = [
    {
        key: 'group-users',
        label: 'Revenue Over Time' 
    },
    {
        key: 'orders',
        label: 'Orders' 
    },
    {
        key: 'refund',
        label: 'Refunds' 
    },
    {
        key: 'customers',
        label: 'Customers' 
    }
];

export const userInformationChartData = {
    colors: ["#43A047", "#F9A825", "#EF5350", "#8E24AA"],
    labels: ["Total Wholesalers", "Pending Requests", "Rejected Requests", "Grouped Users"],
} ;